import React from "react"
import ContentLoader from "react-content-loader"

// https://skeletonreact.com
const VideoPreviewHorizontalPlaceholder = (props) => (
  <ContentLoader 
    speed={2}
    width={"100%"}
    height={191}
    // viewBox="0 0 340 241"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    {/* <rect x="0" y="0" rx="15" ry="15" width="340" height="191" /> 
    <rect x="347" y="7" rx="5" ry="5" width="calc(100% - 347px)" height="15" /> 
    <rect x="347" y="27" rx="5" ry="5" width="calc(calc(100% - 347px) - 25%)" height="15" />
    <circle cx="370" cy="76" r="23" /> 
    <rect x="400" y="57" rx="5" ry="5" width="187" height="15" /> 
    <rect x="400" y="80" rx="5" ry="5" width="142" height="15" /> */}
    
    <rect x="0" y="0" width="340" height="191" /> 
    <rect x="347" y="7" width="calc(100% - 347px)" height="15" /> 
    <rect x="347" y="27" width="calc(calc(100% - 347px) - 25%)" height="15" />
    <rect x="347" y="53" width="46" height="46" /> 
    <rect x="400" y="57" width="187" height="15" /> 
    <rect x="400" y="80" width="142" height="15" />
  </ContentLoader>
)

export default VideoPreviewHorizontalPlaceholder
